// extracted by mini-css-extract-plugin
export var active = "_hf-2";
export var recordingDot = "_hf-1";
export var recordingIndicator = "_hf-0";